import { useLang } from "@/lib/i18n";
import { whatsappUrl, CONTACT } from "@/lib/translations";

export const Footer = () => {
  const { lang, t } = useLang();

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0d0d0d] text-neutral-300 pt-20 md:pt-28 pb-10"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-y-12 lg:gap-x-12 mb-20">
          <div className="col-span-12 lg:col-span-6">
            <div className="flex items-baseline gap-1 mb-8">
              <span className="font-serif text-4xl md:text-5xl tracking-tight text-white">
                Girona
              </span>
              <span className="font-serif italic text-4xl md:text-5xl tracking-tight text-neutral-400">
                Webs
              </span>
              <span className="ml-2 mt-2 w-2 h-2 rounded-full bg-emerald-400" />
            </div>
            <p className="font-serif text-2xl md:text-3xl leading-tight tracking-tight text-neutral-200 max-w-md">
              {t.footer.tagline}
            </p>

            <a
              data-testid="footer-cta"
              href={whatsappUrl(lang)}
              target="_blank"
              rel="noopener noreferrer"
              className="group mt-10 inline-flex items-center gap-3 px-1 py-3 border-b border-neutral-400 text-[12px] tracking-[0.15em] uppercase hover:border-white hover:text-white transition-all"
            >
              {t.floatingCta}
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M7 17L17 7M7 7h10v10" />
              </svg>
            </a>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <div className="overline text-neutral-500 mb-5">{t.footer.sections.studio}</div>
            <ul className="space-y-3 text-sm">
              <li><a href="#top" className="hover:text-white transition-colors">{t.footer.links.about}</a></li>
              <li><a href="#work" className="hover:text-white transition-colors">{t.footer.links.work}</a></li>
              <li><a href="#process" className="hover:text-white transition-colors">{t.footer.links.process}</a></li>
              <li><a href="#contact" className="hover:text-white transition-colors">{t.footer.links.journal}</a></li>
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <div className="overline text-neutral-500 mb-5">{t.footer.sections.services}</div>
            <ul className="space-y-3 text-sm">
              <li><a href="#services" className="hover:text-white transition-colors">{t.footer.links.web}</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">{t.footer.links.shop}</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">{t.footer.links.seo}</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">{t.footer.links.care}</a></li>
            </ul>
          </div>

          <div className="col-span-12 lg:col-span-2">
            <div className="overline text-neutral-500 mb-5">{t.footer.sections.contact}</div>
            <ul className="space-y-3 text-sm">
              <li><a href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors">{CONTACT.email}</a></li>
              <li><a href={whatsappUrl(lang)} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">WhatsApp · {CONTACT.whatsappDisplay}</a></li>
              <li><span className="text-neutral-400">Girona</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-neutral-800 pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-neutral-500">
          <span>{t.footer.legal}</span>
          <span>{t.footer.policy}</span>
        </div>
      </div>
    </footer>
  );
};
